import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../store";

const initialState: TargetOrderState = {
  orderType: ["Buy"],
  // Token Trade Amount
  tradeAmount: undefined,
  targetPrice: undefined,
  ctSuccess: false,
  viewSummery: false,
  targetCurrencyCode: "",
  formValid: false,
  filterOption: "all",
  filterToken: undefined,
  sortOption: "none",
  formCompletion: {
    tokenValueInput: false,
    currencyValueInput: false,
    tokenInput: false,
    currencyInput: false,
  },

  // Token Selection.
  selectedToken: {
    icon: "",
    code: "",
    balance: 0,
    units: 0,
    available: 0,
    price: 0,
    type: "",
    value: 0,
    selected: false,
  },
  // Currency Selection.
  selectedCurrency: {
    name: "",
    icon: "",
    code: "",
    balance: 0,
    units: 0,
    available: 0,
    price: 0,
    type: "",
    value: 0,
    selected: false,
  },
};

export interface TargetOrderState {
  orderType: string[];
  formCompletion: any;
  ctSuccess: boolean;
  tradeAmount?: number;
  filterOption?: "all" | "buy" | "sell";
  filterToken?: string;
  sortOption?: "date" | "targetHighest" | "targetLowest" | "targetClosest" | "none";
  formValid: boolean;
  targetPrice?: number;
  viewSummery: boolean;
  targetCurrencyCode: string;
  selectedToken: SelectedStateType;
  selectedCurrency: SelectedCurrencyType;
}

export interface SelectedStateType {
  icon?: string;
  code: string;
  available?: number;
  balance?: number;
  units?: number;
  price?: number;
  type?: string;
  value?: number;
  selected: boolean;
}

export interface SelectedCurrencyType {
  icon?: string;
  code: string;
  name: string;
  available?: number;
  balance?: number;
  units?: number;
  price?: number;
  type?: string;
  value?: number;
  selected: boolean;
}
const resetState = (state: TargetOrderState) => {
  const reset = { ...initialState };
  //update the copy's orderType property with the current state's
  reset.orderType = state.orderType;
  return reset;
};
const TargetOrderSlice = createSlice({
  name: "targets",
  initialState: initialState,
  reducers: {
    resetForm: (state) => resetState(state),
    setSelectedToken(state, action: PayloadAction<any>) {
      state.selectedToken = action.payload;
    },
    setSelectedCurrency(state, action: PayloadAction<any>) {
      state.selectedCurrency = action.payload;
    },
    setCtSuccess(state, action: PayloadAction<boolean>) {
      state.ctSuccess = action.payload;
    },
    setTargetOrderType(state) {
      state.orderType[0] = state.orderType[0] === "Buy" ? "Sell" : "Buy";
    },
    setTargetOrderBuy(state) {
      state.orderType[0] = "Sell";
    },
    setTargetTradeAmount(state, action) {
      state.tradeAmount = action.payload;
    },
    toggleSummeryView(state) {
      state.viewSummery = !state.viewSummery;
    },

    toggleValidForm(state) {
      state.formValid = !state.formValid;
    },
    setTargetPrice(state, action) {
      state.targetPrice = action.payload;
    },
    setFilterRedux(state, action) {
      state.filterOption = action.payload;
    },
    setTokenRedux(state, action) {
      state.filterToken = action.payload;
    },
    setSortRedux(state, action) {
      state.sortOption = action.payload;
    },
    setCompletedFormSection(state, action) {
      state.formCompletion = {
        ...state.formCompletion,
        ...{ [action.payload]: true },
      };
    },
    resetFormField(state, action) {
      state.formCompletion = {
        ...state.formCompletion,
        ...{ [action.payload]: false },
      };
    },
  },
});

export const {
  setSelectedToken,
  setCtSuccess,
  resetFormField,
  setTargetOrderType,
  setTargetOrderBuy,
  setTargetTradeAmount,
  setTargetPrice,
  setCompletedFormSection,
  setSelectedCurrency,
  toggleSummeryView,
  toggleValidForm,
  resetForm,
  setFilterRedux,
  setTokenRedux,
  setSortRedux,
} = TargetOrderSlice.actions;
export const useTargetState = () => useAppSelector((state) => state.targets);
export default TargetOrderSlice;
